// Chakra imports
import { Box, Flex, Image, Text, useColorModeValue } from '@chakra-ui/react';
import FixedPlugin from 'components/fixedPlugin/FixedPlugin';
import PropTypes from 'prop-types';

function AuthIllustration(props) {
  const { children, illustrationBackground, image } = props;
  const pageBackground = useColorModeValue('white', 'gray.900');
  const panelBackground = useColorModeValue('gray.100', 'gray.800');
  const overlayTint = useColorModeValue('transparent', 'rgba(15, 23, 42, 0.65)');
  const overlayOpacity = useColorModeValue(1, 0.75);
  const gridTopOpacity = useColorModeValue(0.85, 0.55);
  const gridBottomOpacity = useColorModeValue(0.75, 0.45);
  const footerTextColor = useColorModeValue('gray.600', 'gray.300');
  const logoSrc = image || illustrationBackground;

  return (
    <Flex
      h={{ base: 'auto', md: '100vh' }}
      minH="100vh"
      w="100%"
      bg={pageBackground}
      overflow="hidden"
      position="relative"
    >
      <Flex direction={{ base: 'column', md: 'row' }} w="100%" minH="100vh">
        <Flex
          direction="column"
          flex={{ base: 'none', md: '1' }}
          w={{ base: '100%', md: '50%' }}
          h={{ base: 'auto', md: '70%', sm: '100%' }}
          px={{ base: 6, md: 12 }}
          py={{ base: 10, md: 12 }}
          justify="center"
          align={{ base: 'stretch', md: 'center' }}
          gap={10}
          zIndex="1"
        >
          <Box w="100%" maxW={{ base: '100%', md: '420px' }}>
            {children}
          </Box>
          <Text
            position="fixed"
            fontSize="sm"
            bottom="10"
            color={footerTextColor}
            textAlign={{ base: 'left', md: 'center' }}
          >
            ©2025 - 2025 Bamyan Entertainment | All Rights Reserved.
          </Text>
        </Flex>
        <Flex
          position="relative"
          flex={{ base: 'none', md: '1.2' }}
          h={{ base: '320px', md: '100%' }}
          display={{ base: 'none', md: 'flex' }}
          overflow="hidden"
          align="center"
          justify="center"
        >
          <Box position="absolute" inset="0" bg={panelBackground} />
          <Box position="absolute" inset="0" bg={overlayTint} opacity={overlayOpacity} />
          <Image
            src="/grid-01.svg"
            alt="Decorative grid"
            position="absolute"
            top="0px"
            right="0px"
            w={{ md: '320px', lg: '420px', xl: '520px' }}
            opacity={gridTopOpacity}
            pointerEvents="none"
          />
          <Image
            src="/grid-01.svg"
            alt="Decorative grid"
            position="absolute"
            bottom="0px"
            left="0px"
            w={{ md: '320px', lg: '420px', xl: '520px' }}
            opacity={gridBottomOpacity}
            pointerEvents="none"
            transform="rotate(180deg)"
          />
          {logoSrc && (
            <Image
              src={logoSrc}
              alt="BamyanEntertainment logo"
              maxW={{ md: '260px', lg: '320px', xl: '410px' }}
              objectFit="contain"
              zIndex="1"
            />
          )}
          <Text
            position="absolute"
            bottom="40px"
            left="50%"
            transform="translateX(-50%)"
            fontSize="sm"
            color={footerTextColor}
            zIndex="1"
            textAlign="center"
          >
            Powered by: Webify Company
          </Text>
        </Flex>
      </Flex>
      <FixedPlugin />
    </Flex>
  );
}
// PROPS

AuthIllustration.propTypes = {
  illustrationBackground: PropTypes.string,
  image: PropTypes.any,
};

export default AuthIllustration;
